export class BuildInfo {
    appVersion: string = '';
    buildDate: string = '';
    buildVersion: string = '';
    branch: string = '';
    buildNumber: string = '';
    commitSha: string = '';
}
